﻿/*
 * Purpose: Presentational input fields for LegalGuardian form.
 * Boundary: Pure UI; controlled by parent; no local state.
 * Invariants:
 * - ASCII only; placeholders and labels use plain ASCII text.
 */

// Component IdField:
// Controlled input for numeric South African ID (13 digits)
export function IdField({ value, onChange, id, className = "" }) {
    // Rendering - numeric field limited to 13 digits
    return (
        <label className={`grid gap-1 ${className}`} htmlFor={id}>
            <span className="text-sm text-neutral-300">ID Number</span>
            <input
                id={id}
                inputMode="numeric"
                maxLength={13}
                className="bg-neutral-900 rounded-lg px-1 py-2 md:px-3 md:py-2 ring-1 ring-neutral-800 focus:ring-emerald-600 outline-none"
                value={value}
                onChange={onChange}
                placeholder="13 digits"
                required
            />
        </label>
    );
}

// Component AgeField:
// Read-only display showing derived age
export function AgeField({ value, className = "" }) {
    // Rendering - locked field displaying calculated age
    return (
        <label className={`grid gap-1 ${className}`}>
            <span className="text-sm text-neutral-300">Age</span>
            <input
                type="text"
                className="bg-neutral-900 rounded-lg px-3 py-2 ring-1 ring-neutral-800 outline-none cursor-not-allowed"
                value={value ?? ""}
                placeholder="Enter ID number first..."
                readOnly
            />
        </label>
    );
}

// Component NameField:
// Controlled text input with accessible label
export function NameField({ id, label, value, onChange }) {
    // Rendering - single-line labeled text field
    return (
        <label className="grid gap-1" htmlFor={id}>
            <span className="text-sm text-neutral-300">{label}</span>
            <input
                id={id}
                className="bg-neutral-900 rounded-lg px-1 py-2 md:px-3 md:py-2 ring-1 ring-neutral-800 focus:ring-emerald-600 outline-none"
                value={value}
                onChange={onChange}
                required
            />
        </label>
    );
}
